import { takeLatest, call, put } from "redux-saga/effects";
import {
  SUBMIT_FETCH_BENCHMARKING_REQUEST,
  submitFetchBenchmarkingSuccess,
  submitFetchBenchmarkingFailure,
} from "../actions/fetchBenchmarkingActions";
import { fetchBenchmarkingResultsNew } from "../../../services/accIqService";

// Worker Saga
function* handleFetchBenchmarkingSubmission(action) {
  try {
    const { client_company, dimension } = action.payload;
    const response = yield call(
      fetchBenchmarkingResultsNew,
      client_company,
      dimension
    );
    yield put(submitFetchBenchmarkingSuccess(response));
  } catch (error) {
    yield put(
      submitFetchBenchmarkingFailure(error?.message || "Something went wrong")
    );
  }
}

// Watcher Saga
export function* watchFetchBenchmarkingSubmission() {
  yield takeLatest(
    SUBMIT_FETCH_BENCHMARKING_REQUEST,
    handleFetchBenchmarkingSubmission
  );
}
